import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { BASE_DOMAIN } from "../../lib/subdomain";

// Leaflet + bundlers necesitan que se reconfiguren manualmente las rutas de
// los íconos por defecto del marcador, si no se ven "rotos" (ícono roto).
const iconoPorDefecto = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = iconoPorDefecto;

export interface NegocioConCoordenadas {
  id: string;
  nombre: string;
  subdominio: string;
  direccion?: string | null;
  latitud?: number | null;
  longitud?: number | null;
}

export function NegociosMapa({ negocios }: { negocios: NegocioConCoordenadas[] }) {
  const conUbicacion = negocios.filter(
    (n): n is NegocioConCoordenadas & { latitud: number; longitud: number } =>
      typeof n.latitud === "number" && typeof n.longitud === "number"
  );

  const centro: [number, number] =
    conUbicacion.length > 0
      ? [conUbicacion[0].latitud, conUbicacion[0].longitud]
      : [23.6345, -102.5528]; // Centro geográfico aproximado de México como respaldo.

  if (negocios.length > 0 && conUbicacion.length === 0) {
    return (
      <div className="card p-6 text-center text-sm text-slate-500">
        Ninguno de tus negocios tiene un domicilio que se haya podido ubicar en el mapa todavía.
        Agrega o corrige el domicilio de un negocio para que aparezca aquí.
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="h-96">
        <MapContainer center={centro} zoom={conUbicacion.length > 1 ? 5 : 12} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {conUbicacion.map((n) => (
            <Marker key={n.id} position={[n.latitud, n.longitud]}>
              <Popup>
                <p className="font-semibold">{n.nombre}</p>
                <p className="text-xs text-slate-500">{n.subdominio}.{BASE_DOMAIN}</p>
                {n.direccion && <p className="text-xs mt-1">{n.direccion}</p>}
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      {negocios.length > conUbicacion.length && (
        <p className="text-xs text-slate-400 p-3 border-t border-slate-100">
          {negocios.length - conUbicacion.length} negocio(s) sin domicilio ubicado en el mapa todavía.
        </p>
      )}
    </div>
  );
}
